@use "~theme/breakpoints";
@use "./tokens";

.card {
  border-radius: 20px;
  box-shadow: 0 4px 4px 0 rgb(0 0 0 / 10%);
  background-color: var(--white);
  max-width: var(--max-desktop-width);
  flex-grow: 1;
  margin: 18px var(--card-gutter-width);
}

.desktopOnly {
  margin: 0;
  border-radius: 0;
  box-shadow: none;

  @include breakpoints.desktop {
    @include tokens.card;
  }
}
